import { render, staticRenderFns } from "./DepartmentComponent.vue?vue&type=template&id=68640b8c&scoped=true&"
import script from "./DepartmentComponent.vue?vue&type=script&lang=js&"
export * from "./DepartmentComponent.vue?vue&type=script&lang=js&"
import style0 from "./DepartmentComponent.vue?vue&type=style&index=0&id=68640b8c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68640b8c",
  null
  
)

export default component.exports